import React, { useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";
import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";
import InputVehcile from "components/form/InputVehcile";
import Error from "components/form/Error";
import DrawerButton from "components/form/DrawerButton";
import useVehicle from "hooks/useVehicle";
import SelectReferenceNo from "components/form/SelectReferenceNo";
import SelectVehicle from "components/form/SelectVehicle";
import Uploader from "components/image-uploader/Uploader";
import { FiX } from "react-icons/fi";

const VehicleDrawer = ({ id, isViewMode }) => {
  const [vehicleReg, setVehicleReg] = useState(["", "", "", ""]);

  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    allVehicleCategory,
    setExistingImageInterior1,
    setExistingImageregurl5,
    setExistingImageInterior2,
    setExistingImageExterior1,
    setExistingImageExterior2,
    selectedReferenceNo,
    setselectedReferenceNo,
    interiorUrl1,
    setInteriorUrl1,
    interiorUrl2,
    setInteriorUrl2,
    exteriorUrl1,
    setExteriorUrl1,
    exteriorUrl2,
    regurl,
    setRegurl,
    setExteriorUrl2,
    loading,
    setValue,
  } = useVehicle(id, vehicleReg, setVehicleReg);

  const handleCancelImage = () => {
    setInteriorUrl1("");
    // setExistingImageInterior1("");
  };

  const handleCancelImage2 = () => {
    setInteriorUrl2("");
    // setExistingImageInterior2("");
  };
  const handleCancelImage3 = () => {
    setExteriorUrl1("");
    // setExistingImageExterior1("");
  };
  const handleCancelImage4 = () => {
    setExteriorUrl2("");
    // setExistingImageExterior2("");
  };

  const handleCancelImage5 = () => {
    setRegurl("");
    // setExistingImageregurl5("");
  };

  const currentDate=new Date();
  const currentyear=currentDate.getFullYear();
  const maxYear=currentyear+1;
  const minYear=currentyear-8

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title register={register} title="Edit Vehicle" />
        ) : (
          <Title register={register} title="Add Vehicle" />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card className="  flex-grow scrollbar-hide w-full max-h-full">
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="pt-4 flex-grow scrollbar-hide w-full max-h-full pb-40">
                <div className="grid grid-cols-12 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                  <div className="col-span-6">
                    <LabelArea label="Vendor Name" required />
                    <SelectReferenceNo
                      register={register}
                      label="Vendor Reference No"
                      name="vendor_id"
                      selectedReferenceNoId={selectedReferenceNo}
                      handleReferenceNoChange={setselectedReferenceNo}
                    />

                    <Error errorName={errors.vendor_id} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Vehicle Modal" required />
                    <SelectVehicle
                      register={register}
                      name="vehicle_name_id"
                      label="Vehicle Modal"
                      allVehicleCategory={allVehicleCategory}
                      required={true}
                      errors={errors}
                    />
                    <Error errorName={errors.vehicle_name_id} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Registration No." required />
                    <InputVehcile
                      vehicleReg={vehicleReg}
                      onChange={setVehicleReg}
                      trigger={trigger}
                      setValue={setValue}
                      register={register} // Pass register here
                      errors={errors} // Pass errors here for validation display
                    />
                    <Error errorName={errors.vehicle_reg_no} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Year of Vehicle Manufactured" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Year of Vehicle Manufactured"
                      name="year_of_vehicle_manufactured"
                      type="number"
                      placeholder="Year of Vehicle Manufactured"
                      pattern={/^[0-9]{4}$/}
                      required={true}
                      maxLength={4}
                      min={minYear}
                      max={maxYear}
                    />
                    <Error errorName={errors.year_of_vehicle_manufactured} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea label={"Interior Image 1 (Optional)"} />
                    {interiorUrl1 ? (
                      <div className="flex items-center">
                        <img
                          style={{
                            objectFit: "cover",
                            width: "250px",
                            height: "100px",
                            borderRadius: "10px",
                          }}
                          src={
                            process.env.REACT_APP_API_IMAGE_URL + interiorUrl1
                          }
                          alt="caricon"
                        />
                        {!isViewMode ? (
                          <FiX size={25} onClick={handleCancelImage} />
                        ) : null}
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={false}
                        folder="vehicle"
                        name_merge="interior_img_1"
                        imageUrl={interiorUrl1}
                        setImageUrl={setInteriorUrl1}
                        no_of_image={1}
                        required={true}
                      />
                    )}
                    <Error errorName={errors.interior_img_1} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea label={"Interior Image 2 (Optional)"} />
                    {interiorUrl2 ? (
                      <div className="flex items-center">
                        <img
                          style={{
                            objectFit: "cover",
                            width: "250px",
                            height: "100px",
                            borderRadius: "10px",
                          }}
                          src={
                            process.env.REACT_APP_API_IMAGE_URL + interiorUrl2
                          }
                          alt="caricon"
                        />
                        {!isViewMode ? (
                          <FiX size={25} onClick={handleCancelImage2} />
                        ) : null}
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={false}
                        folder="vehicle"
                        name_merge="interior_img_2"
                        imageUrl={interiorUrl2}
                        setImageUrl={setInteriorUrl2}
                        no_of_image={1}
                        required={true}
                      />
                    )}
                    <Error errorName={errors.interior_img_2} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea label={"Exterior Image 1 (Optional)"} />
                    {exteriorUrl1 ? (
                      <div className="flex items-center">
                        <img
                          style={{
                            objectFit: "cover",
                            width: "250px",
                            height: "100px",
                            borderRadius: "10px",
                          }}
                          src={
                            process.env.REACT_APP_API_IMAGE_URL + exteriorUrl1
                          }
                          alt="caricon"
                        />
                        {!isViewMode ? (
                          <FiX size={25} onClick={handleCancelImage3} />
                        ) : null}
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={false}
                        folder="vehicle"
                        name_merge="exterior_img_1"
                        imageUrl={exteriorUrl1}
                        setImageUrl={setExteriorUrl1}
                        no_of_image={1}
                        required={true}
                      />
                    )}
                    <Error errorName={errors.exterior_img_1} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea label={"Exterior Image 2 (Optional)"} />
                    {exteriorUrl2 ? (
                      <div className="flex items-center">
                        <img
                          style={{
                            objectFit: "cover",
                            width: "250px",
                            height: "100px",
                            borderRadius: "10px",
                          }}
                          src={
                            process.env.REACT_APP_API_IMAGE_URL + exteriorUrl2
                          }
                          alt="caricon"
                        />
                        {!isViewMode ? (
                          <FiX size={25} onClick={handleCancelImage4} />
                        ) : null}
                      </div>
                    ) : (
                      <Uploader
                        is_multiple={false}
                        folder="vehicle"
                        name_merge="exterior_img_2"
                        imageUrl={exteriorUrl2}
                        setImageUrl={setExteriorUrl2}
                        no_of_image={1}
                        required={true}
                      />
                    )}
                    <Error errorName={errors.exterior_img_2} />
                  </div>
                </div>

                <div className="col-span-12">
                  <LabelArea label={"Registration Certificate (Optional)"} />
                  {regurl ? (
                    <div className="flex items-center">
                      <img
                        style={{
                          objectFit: "cover",
                          width: "250px",
                          height: "100px",
                          borderRadius: "10px",
                        }}
                        src={process.env.REACT_APP_API_IMAGE_URL + regurl}
                        alt="caricon"
                      />
                      {!isViewMode ? (
                        <FiX size={25} onClick={handleCancelImage5} />
                      ) : null}
                    </div>
                  ) : (
                    <Uploader
                      is_multiple={false}
                      folder="vehicle"
                      name_merge="reg_cer_img"
                      imageUrl={regurl}
                      setImageUrl={setRegurl}
                      no_of_image={1}
                      required={true}
                    />
                  )}
                  <Error errorName={errors.reg_cer_img} />
                </div>
              </div>

              <DrawerButton
                isSubmitting={loading}
                id={id}
                title={id ? "Update" : "Submit"}
              />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default VehicleDrawer;
